var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessages3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 15.375V23.025C39 24.93 38.37 26.535 37.245 27.645C36.135 28.77 34.53 29.4 32.625 29.4V32.115C32.625 33.135 31.485 33.75 30.645 33.18L29.19 32.22C29.325 31.755 29.385 31.245 29.385 30.705V24.6C29.385 21.54 27.345 19.5 24.285 19.5H14.1C13.89 19.5 13.695 19.515 13.5 19.53V15.375C13.5 11.55 16.05 9 19.875 9H32.625C36.45 9 39 11.55 39 15.375Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.385 24.6V30.705C29.385 31.245 29.325 31.755 29.19 32.22C28.635 34.425 26.805 35.805 24.285 35.805H20.205L15.675 38.82C15 39.285 14.1 38.79 14.1 37.98V35.805C12.57 35.805 11.295 35.295 10.41 34.41C9.51 33.51 9 32.235 9 30.705V24.6C9 21.75 10.77 19.785 13.5 19.53C13.695 19.515 13.89 19.5 14.1 19.5H24.285C27.345 19.5 29.385 21.54 29.385 24.6Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages3);
export default __webpack_public_path__ + "static/media/messages3.c12d64fb432b02bafafc4466de4e70b7.svg";
export { ForwardRef as ReactComponent };